var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-draggable-resize-combo",
    {
      staticClass: "container",
      attrs: {
        x: _vm.qrcode.X,
        y: _vm.qrcode.Y,
        width: _vm.qrcode.Width,
        height: _vm.qrcode.Height,
        "min-width": 5,
        "min-height": 5,
      },
      on: {
        "update:x": function ($event) {
          return _vm.$set(_vm.qrcode, "X", $event)
        },
        "update:y": function ($event) {
          return _vm.$set(_vm.qrcode, "Y", $event)
        },
        "update:width": function ($event) {
          return _vm.$set(_vm.qrcode, "Width", $event)
        },
        "update:height": function ($event) {
          return _vm.$set(_vm.qrcode, "Height", $event)
        },
      },
    },
    [
      _c("img", {
        staticClass: "qrcode",
        attrs: { src: "/img/winfakt-be-qr.png", alt: "Qrcode" },
        on: {
          mousedown: function ($event) {
            $event.preventDefault()
          },
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }